import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LockExtensionDialogComponent } from '@libs/shared/ui/dialogs/lock-extension-dialog/lock-extension-dialog.component';
import { Observable } from 'rxjs';

@Injectable()
export class LockExtensionDialogService {
  constructor(private _matDialog: MatDialog) {}

  open(
    leftSeconds$: Observable<number>
  ): MatDialogRef<LockExtensionDialogComponent, string> {
    return this._matDialog.open(LockExtensionDialogComponent, {
      autoFocus: true,
      disableClose: false,
      data: leftSeconds$,
    });
  }
}
